const triageEnum = {
  none: {
    value: 0,
    name: 'none',
  },
  inconclusive: {
    value: 1,
    name: 'inconclusive',
  },
  standard: {
    value: 2,
    name: 'standard',
  },
  immediate: {
    value: 3,
    name: 'immediate',
  },
  urgent: {
    value: 4,
    name: 'urgent',
  },
};

function recommendTriage(triage_map, severity) {
  let triageRecommendation = triageEnum.none.name;
  try {
    const triageExists = triage_map.find((t) => t.severity === severity);

    if (triageExists) {
      triageRecommendation = triageExists.triage;
    }
  } catch (e) {
    // swallow exception
  }
  return triageRecommendation;
}

function highestTriage(triage1, triage2) {
  const triage1Value = triageEnum[triage1].value;
  const triage2Value = triageEnum[triage2].value;

  return triage1Value > triage2Value ? triage1 : triage2;
}

module.exports = {
  highestTriage,
  recommendTriage,
  triageEnum,
};
